import type { FC } from "react"
import { useState } from "react"

import { urlSchema } from "@logic/lib/validation"
import { useTranslation } from "react-i18next"
import type { SetterOrUpdater } from "recoil"
import styled from "styled-components"

import Button from "~/components/Button"
import FormFooter from "~/components/FormFooter"
import FormWrapper from "~/components/styles/FormWrapper"
import { useDesignRequest } from "~/containers/Proposal/state/design-request/use-design-request"
import { TextInput } from "~/ui/lib/input/TextInput"
import { getPowurUrl } from "~/utils/getUrlForEnvironment"

const Wrapper = styled(FormWrapper)`
  display: inline-flex;
  flex-direction: column;
  width: 50vw;
  background-color: var(--white);
  position: absolute;
  z-index: 201;
  top: 35vh;
  left: 25vw;
  border-radius: 10px;
`

export const PauseRequestModal: FC<{
  setPauseRequestModalIsOpen: SetterOrUpdater<boolean>
}> = ({ setPauseRequestModalIsOpen }) => {
  const { t } = useTranslation()
  const { pause: pauseDesignRequest } = useDesignRequest()
  const [url, setUrl] = useState(``)

  const isUrl = (value: string): string | undefined => {
    try {
      return urlSchema.parse(value) && undefined
    } catch (e) {
      return t(`mustBeAValidUrl`)
    }
  }

  const onSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault()
    await pauseDesignRequest(url)
    setPauseRequestModalIsOpen(false)
    window.location.assign(`${getPowurUrl()}/admin-solar-proposals/vision`)
  }

  return (
    <Wrapper>
      <form onSubmit={onSubmit}>
        <section>
          <TextInput
            error={isUrl(url)}
            label={t(`ticketUrl`)}
            id="ticket-url"
            name="ticket-url"
            type="text"
            placeholder={t(`enterTicketUrl`)}
            value={url}
            onChange={(e) => setUrl(e.target.value)}
          />
        </section>
        <FormFooter>
          <Button type="submit" disabled={isUrl(url) !== undefined}>
            {t(`submit`)}
          </Button>
        </FormFooter>
      </form>
    </Wrapper>
  )
}
